import { createUseStyles } from "react-jss";

export default createUseStyles({
    textAnswer: {
        composes: "text-answer",
    },
    textAnswerMultiLine: {
        composes: "text-answer--multi-line",
    },
    textAnswerNumeric: {
        composes: "text-answer--numeric",
    },
    textAnswerDateTime: {
        composes: "text-answer--date-time",
    },
});
